<template>
  <div
    v-if="columnHeight !== 0"
    :class="[{[$style.jcColumn]: isJcColumn}, {[$style.columnSlice]: isJcColumn}]"
    :style="{ height: `${(columnHeight / columnHeightMax) * 100 }%` }"
  >
    <div v-if="isJcColumn && usersCount > 10">
      {{ columnSlices[0] }}
    </div>
    <div
      v-else
      :class="$style.competitionColumnContainer"
    >
      <div
        v-for="(columnSlice, index) of columnSlices"
        :key="index"
        :class="[$style.columnSlice, $style.competitionColumn]"
        :style="`
          --columnSliceColor: ${color(index)};
          --columnSliceHeight: ${height(columnSlice, columnSlices)}
          `"
      >
        <Tooltip
          :heading="columnSlice.name"
          :text="hoverPrice(columnSlice)"
        >
          {{ columnSlice.name }}
        </Tooltip>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Tooltip,
} from '@jumpcloud/ui-components';

export default {
  name: 'BarGraph',

  components: {
    Tooltip,
  },

  props: {
    columnHeight: {
      type: Number,
      default: undefined,
      required: false,
    },
    columnHeightMax: {
      type: Number,
      default: undefined,
      required: false,
    },
    columnSlices: {
      type: Array,
      default: () => [],
      required: false,
    },
    isJcColumn: {
      type: Boolean,
    },
    startColumnSliceColor: {
      type: Number,
      default: 116,
    },
    usersCount: {
      type: Number,
      default: undefined,
      required: false,
    },
  },

  methods: {
    color(index) {
      const rgba = this.startColumnSliceColor - index * 10;
      return `rgba(${rgba},${rgba},${rgba})`;
    },

    height(columnSlice, columnSlices) {
      let total = 0;
      columnSlices.forEach((slice) => {
        total += slice.price;
      });
      const heightValue = ((columnSlice.price / total) * 100).toFixed(2);
      return `${heightValue}%`;
    },

    hoverPrice(columnSlice) {
      const featurePrice = (columnSlice.price * this.usersCount);
      return `$${featurePrice}`;
    },
  },
};
</script>
<style module>
.columnSlice {
  align-items: center;
  color: white;
  display: flex;
  font-size: var(--jcBodyTiny);
  justify-content: center;
}

.competitionColumnContainer {
  height: 100%;
}

.competitionColumn {
  background: var(--columnSliceColor);
  height: var(--columnSliceHeight);
}

.jcColumn {
  background: var(--jcInformational);
  color: black;
}
</style>
